import { FedEvent } from '../../types/entities';

export interface FedCalendarState {
  loading: boolean;
  loaded: boolean;
  error?: string;
  events: FedEvent[];
}

export const initialState: FedCalendarState = {
  loading: false,
  loaded: false,
  error: undefined,
  events: []
};
